import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ConfirmDialog from '../../../../components/ConfirmDialog/ConfirmDialog';
import { formatDate } from '../../../../utils/Utils';

/** Mesmo valor de TrialService::REOPENED_TRIAL_DAYS (o servidor é quem grava a data). */
export const REOPEN_TRIAL_DAYS = 14;

const RUNNING_SUBSCRIPTION = ['active', 'trialing', 'canceling', 'past_due'];

/**
 * Motivo para o botão ficar desabilitado, espelhando as recusas de reopen_trial.php;
 * null quando a empresa pode receber um novo período de teste.
 * @param {Object} company resposta de get.php
 * @returns {string|null}
 */
export function reopenTrialBlockedReason(company) {
  const subscription = company?.subscription;
  if (subscription?.is_active && RUNNING_SUBSCRIPTION.includes(subscription.status)) {
    return 'A empresa tem uma assinatura ativa. O novo período de teste é só para quem não assina.';
  }
  const endsAt = company?.trial_ends_at ? new Date(company.trial_ends_at.replace(' ', 'T')) : null;
  if (endsAt && !Number.isNaN(endsAt.getTime()) && endsAt > new Date()) {
    return `O período de teste ainda está em andamento, até ${formatDate(endsAt)}.`;
  }
  return null;
}

/**
 * ReopenCompanyTrialDialog - Confirmação de "Liberar novo período de teste" (Admin Geral)
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {{ name: string, closure?: Object|null }|null} props.company
 * @param {boolean} props.loading
 * @param {Function} props.onConfirm
 * @param {Function} props.onCancel
 */
function ReopenCompanyTrialDialog({ isOpen, company, loading, onConfirm, onCancel }) {
  const newEnd = new Date();
  newEnd.setDate(newEnd.getDate() + REOPEN_TRIAL_DAYS);
  const inClosure = company?.closure?.state === 'grace' || company?.closure?.state === 'expired';

  return (
    <ConfirmDialog
      isOpen={isOpen}
      title="Liberar novo período de teste"
      variant="info"
      confirmLabel="Liberar teste"
      cancelLabel="Cancelar"
      onConfirm={onConfirm}
      onCancel={onCancel}
      loading={loading}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {company?.name && (
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: 'text.primary' }}>
            {company.name}
          </Typography>
        )}
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          A conta volta a ter acesso completo, como num teste normal, por {REOPEN_TRIAL_DAYS} dias:
          até <strong>{formatDate(newEnd)}</strong>.
        </Typography>
        {inClosure && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            O encerramento da conta é cancelado, sem e-mail. Se o teste vencer de novo sem
            assinatura, um novo encerramento começa.
          </Typography>
        )}
      </Box>
    </ConfirmDialog>
  );
}

export default ReopenCompanyTrialDialog;
